import styled from "styled-components";
import modalStyles from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import checkStyles from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

const TitleModalStyled = styled.h4`
  margin: 0;
  line-height: 1.42857143;
  font-weight: bold;
  color: ${(props) => (props.color ? `${props.color}` : "#9c27b0")};
`;
const SubtitleModalStyled = styled.span`
  word-wrap: break-word;
`;
const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const styles = (theme) => ({
  ...modalStyles,
  ...checkStyles,
  modalHeader: {
    ...modalStyles.modalHeader,
    display: "flex",
    justifyContent: "space-between",
  },
  marginLabel: {
    marginRight: "1rem",
  },
});

export { TitleModalStyled, SubtitleModalStyled, CheckboxWrapper, styles };
